import Behaviour from '@/core';
import SponSlide from 'spon-slide';
// import Flickity from 'flickity'
import resizer from 'spon-resize';
import Hammer from 'hammerjs';

export default class Slide extends Behaviour {
	constructor(el) {
		super(el);
		const viewport = resizer();

		const pagerButtonHtml = () =>
			'<button class="c-carousel__pager-btn"></button>';

		this.slide = new SponSlide(this.$el, {
			activeClass: 'is-current',
			loop: true,
			delay: 7000,
			dots: true,
			paginationWrapper: '<div class="c-carousel__pager-wrapper"></div>',
			paginationButtons: slides => slides.map(pagerButtonHtml),
		});

		this.slide.init();

		viewport.start();
		viewport.at('(min-width: 62em)', {
			match: () => {
				log('no swipe');
			},

			unmatch: () => {
				this.mc = new Hammer.Manager(this.$el);
				this.mc.add(
					new Hammer.Swipe({
						direction: 6,
					})
				);
				this.mc.on('swipeleft', () => this.slide.next());
				this.mc.on('swiperight', () => this.slide.next());
			},
		});
	}
}


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
